;(function() {
  'use strict'

  Controller.$inject = ["$element", "publicationService", "featureService"];
  angular.module('app.core').component('publicationCard', {
    controller: Controller,
    templateUrl: 'publication-card.html',
    bindings: {
      publication: '<',
      canRate: '<',
      newRibbon: '<',
      publishedRibbon: '<',
      isTypeHidden: '<',
      layout: '@',
      menu: '<',
    },
  })

  /* @ngInject */
  function Controller($element, publicationService, featureService) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.$onChanges = onChanges
    ctrl.rate = rate

    function onInit() {
      ctrl.imageStyle = {
        backgroundImage: 'url(' + ctrl.publication.getImageUrl(350) + ')',
      }
      ctrl.thumbStyle = ctrl.publication.imageUrl && {
        backgroundImage: 'url(' + ctrl.publication.getImageUrl(160) + ')',
      }
      ctrl.canAddPremiumPublications = featureService.canAddPremiumPublications()
    }

    function onChanges() {
      ctrl.isRow = ctrl.layout === 'row'
      $element.toggleClass('-menu', !!ctrl.menu)
    }

    function rate(stars) {
      publicationService.rate(ctrl.publication, stars)
    }
  }
})()
